<template>
	<QwoachDialogLayout>

			<div>
				<p>Select the unpaid items you want to request payment for:</p>
				<div v-if="invoiceableItems.length > 0">
					<el-checkbox-group  v-model="selectedItems" class="mb-2" @change="onSelectedItemsChanged">
						<div v-for="(item, index) in invoiceableItems" :key="index"
							 class="row align-items-center hover">
							<el-checkbox
								class="col"
								:label="item.id">
								${{item.amount}} - {{item.name || "not set"}}
							</el-checkbox>
							<qw-input class="col" v-model="item.additionalNote"
									  placeholder="Additional notes"
									  :input-debounce-delay="2000"
									  @change="onItemNoteChanged"></qw-input>
						</div>
					</el-checkbox-group>
					<div class="mb-4" style="font-weight: 600;">${{totalAmount}} - Total</div>


					Payment instructions:

					<qw-input
						:multiline="true"
						:min-rows="1"
						class="w-100"
						placeholder="Type the instructions for your client to pay: your bank account, PayPal link, etc"
						v-model="instructions"
						:input-debounce-delay="2000"
						@change="onPayInstructionsChanged">
					</qw-input>
				</div>
				<div v-else>
					<b>There are no unpaid items. Please close this dialog and add a few milestones or manual time entries with non zero amount and they will appear here.</b>
				</div>


			</div>
			<div v-if="!canCreateInvoice" class="text-danger text-right">No active clients to send an invoice.<br/>Please invite a client and let them accept the invite to proceed.</div>
			<template #footer>
				<div class="row dialog-footer mx-0 mt-5" style="text-align: left">
					<el-button size="small" plain type="primary" @click="confirmManually" :disabled="!canCreateInvoice || totalAmount == 0">
						Confirm payments without invoice
					</el-button>
					<div class="layout-spacer"></div>
					<el-button size="small" @click="onCancel">Cancel</el-button>
					<el-button size="small" type="primary" @click="sendInvoice" :disabled="!canCreateInvoice || totalAmount == 0 || this.selectedClients.length == 0">Send invoice
					</el-button>
				</div>
			</template>

	</QwoachDialogLayout>

</template>

<script>

	import BillingData from "@shared/Billing/BillingData";
	import BillingItem from "@shared/Billing/BillingItem";
	import PersonItem from "@shared/Invoice/PersonItem";
	import InvoiceGroup from "@shared/Invoice/InvoiceGroup";
	import CoachingProgram from "@shared/Program/CoachingProgram";
	import QwoachDialogLayout from "@/core/components/Dialogs/QwoachDialog/QwoachDialogLayout.vue";
	import QwoachDialog from "@/core/components/Dialogs/QwoachDialog/QwoachDialog.vue";
	import QwInput from "@/core/components/Controls/QwInput.vue";


	export default {
		name: "CreateInvoiceDialog",
		components: {QwInput, QwoachDialogLayout},
		extends: QwoachDialog,

		props: {
			billingData: BillingData,
			billingItem: BillingItem,
			programItem: CoachingProgram,
			invoiceGroupList: Array,
			clients: Array
		},
		data: () => ({
			invoiceableItems: [],
			selectedItems: [],
			selectedClients: [],
			billingItemsNotes: [],
			instructions: "",
			isConfirmManually: false

		}),

		created() {
			this.invoiceableItems = this.billingData.invoiceableItems(this.invoiceGroupList)
			if (this.billingItem) {
				this.selectedItems.push(this.billingItem.id)
			} else if (this.billingData.isHourly) {
				this.invoiceableItems.forEach(item => item.isHourly ? this.selectedItems.push(item.id) : null)
			}
			if(this.clients){
				this.clients.forEach(client => this.selectedClients.push(client.id))
			}
		},

		methods: {

			onItemNoteChanged(){
				this.$analyticManager.trackEvent("Payment item note changed", this.analyticsPropsMethod())
			},

			onPayInstructionsChanged(){
				this.$analyticManager.trackEvent("Payment instructions changed", this.analyticsPropsMethod())
			},

			onSelectedItemsChanged(){
				this.$analyticManager.trackEvent("Selected items to pay changed", this.analyticsPropsMethod())
			},

			confirmManually() {
				this.isConfirmManually = true
				this.onAction("actionConfirmPayment")
			},
			sendInvoice() {
				this.isConfirmManually = false
				this.onOk()
			},
			createDataItem() {
				let personItems = this.clients.map(client => new PersonItem(client.clientId || client.id, client.name, client.email))

				let invoiceGroup = new InvoiceGroup()
				invoiceGroup.createInvoiceForAll(personItems, this.billingData, this.selectedItems, this.currencyItemGlobal)
				invoiceGroup.setPaymentInstructions(this.instructions)
				invoiceGroup.setBillFrom(new PersonItem(this.userProfile.id, this.userProfile.name, this.userProfile.email))

				return {
					isConfirmManually: this.isConfirmManually,
					invoiceGroup: invoiceGroup,
				}
			},
			findItemById(itemId) {
				return this.billingData.findBillingItemById(itemId)
			}

		},

		computed: {
			totalAmount: {
				cache: false,
				get() {
					return this.selectedItems.reduce((sum, itemId) => sum + this.findItemById(itemId).amount, 0)
				}
			},


			canCreateInvoice(){
				let activeClients = this.clients.filter(client => client.programInfoByProgramId(this.programItem.id).isActive());
				return activeClients.length > 0
			},

			dialogTitle(){
				return "Send invoice or confirm payments manually"
			}
		}


	}
</script>

<style scoped>
	.el-checkbox {
		overflow: hidden;
	}

	.spacer {
		width: 25px;
		display: inline-block
	}
</style>
